export default "__VITE_ASSET__001ZkkxP__"